<template>
  <div class="ma-4 px-4">
    <!-- Search Bar -->
    <v-row class="mt-2 mb-4" align="center">
      <v-col cols="3" md="3">
        <v-text-field
          v-model="usnInput"
          label="Search by USN"
          outlined
          dense
          hide-details
          clearable
          prepend-inner-icon="mdi-magnify"
          placeholder="Enter USN"
          @keyup.enter="searchSessions"
          @click:clear="clearSearch"
        />
      </v-col>
      <v-col cols="2" md="1">
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!usnInput"
          @click="searchSessions"
          block
        >
          <v-icon left>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>
    </v-row>
    <div v-if="searched">
      <div class="py-4">
        <span class="text-5xl font-weight-bold accent--text">
          Student Payment Session
        </span>
      </div>
      <!-- Results Table -->
      <v-row>
        <v-col cols="12">
          <v-sheet outlined>
            <v-data-table
              :headers="studentPaymentSessionHeaders"
              :items="sessions"
              fixed-header
              class="secondary row-height-50"
              :loading="loading"
              loading-text="Fetching payment sessions..."
              :no-data-text="noDataText"
            >
              <!-- Batch + Year combined -->
              <template #[`item.batch`]="{ item }">
                <v-chip small color="primary" dark>
                  {{ item.admission_batch_code }}
                </v-chip>
              </template>

              <template #[`item.year`]="{ item }">
                {{ item.st_month }} {{ item.st_year }} - {{ item.end_month }}
                {{ item.end_year }}
              </template>

              <template #[`item.paid`]="{ item }">
                <v-chip small :color="item.paid === 'Y' ? 'green' : 'red'" dark>
                  {{ item.paid === "Y" ? "Paid" : "Unpaid" }}
                </v-chip>
              </template>

              <template #[`item.invoice_id`]="{ item }">
                {{ item.invoice_id || "—" }}
              </template>
              <template #[`item.plan_id`]="{ item }">
                {{ item.plan_id || "—" }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-col>
      </v-row>
      <div class="py-4">
        <span class="text-5xl font-weight-bold accent--text">
          Student Academic Invoices
        </span>
      </div>
      <v-row>
        <v-col cols="12">
          <v-sheet outlined>
            <v-data-table
              :headers="studentOldPaymentInvoiceHeaders"
              :items="studentAcademicInvoices"
              fixed-header
              class="secondary row-height-50"
              :loading="loading"
              loading-text="Fetching academic payments..."
              :no-data-text="noDataText"
            >
            </v-data-table>
          </v-sheet>
        </v-col>
      </v-row>
      <div class="py-4">
        <span class="text-5xl font-weight-bold accent--text">
          Student Old Invoices
        </span>
      </div>
      <v-row>
        <v-col cols="12">
          <v-sheet outlined>
            <v-data-table
              :headers="computedOldHeaders"
              :items="studentOldInvoices"
              fixed-header
              class="secondary row-height-50"
              :loading="loading"
              loading-text="Fetching academic payments..."
              :no-data-text="noDataText"
            >
            </v-data-table>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  studentPaymentSessionHeaders,
  studentOldPaymentInvoiceHeaders,
} from "@/constants/headers";

export default {
  data() {
    return {
      usnInput: "",
      searchedUsn: "",
      sessions: [],
      loading: false,
      searched: false,
      studentPaymentSessionHeaders,
      studentOldPaymentInvoiceHeaders,
      studentAcademicInvoices: [],
      studentOldInvoices: [],
    };
  },
  computed: {
    noDataText() {
      if (!this.searched) return "Enter a USN and click Search";
      return `No data found for USN: ${this.searchedUsn}`;
    },
    computedOldHeaders() {
      return this.studentOldPaymentInvoiceHeaders.filter(
        (item) => item.value != "fee_raised_batch",
      );
    },
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Student Payment Session" }]);
  },
  methods: {
    async searchSessions() {
      if (!this.usnInput?.trim()) return;

      try {
        this.loading = true;
        this.searched = true;
        this.sessions = [];

        const usn = this.usnInput.trim();

        const [res1, res2, res3, res4, res5] = await Promise.all([
          this.$axios.get(`/get_payment_sessions_by_usn/${usn}`),
          this.$axios.get(`/get_pre_application_fee_payments_by_usn_id`, {
            params: { usn_id: usn },
          }),
          this.$axios.get(`/list_student_admit_plan_bulk_payments`, {
            params: { usn_id: usn },
          }),
          this.$axios.get(`/list_student_invoices_report`, {
            params: { usn_id: usn },
          }),
          this.$axios.get(`/list_old_payment_invoices_report`, {
            params: { usn_id: usn },
          }),
        ]);

        this.sessions = res1.data.data;
        this.studentAcademicInvoices = [
          ...res2.data.data,
          ...res3.data.data,
          ...res4.data.data,
        ];
        this.studentOldInvoices = res5.data.data;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error.response?.data?.message || "Something went wrong",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    clearSearch() {
      this.usnInput = "";
      this.sessions = [];
      this.studentAcademicInvoices = [];
      this.studentOldInvoices = [];
      this.searched = false;
      this.searchedUsn = "";
    },
  },
};
</script>
